module.exports = __webpack_public_path__ + "static/media/moose-big.902c557e.png";